import { render, staticRenderFns } from "./LoginRegisterDialog.vue?vue&type=template&id=3cc1cb1e&"
import script from "./LoginRegisterDialog.vue?vue&type=script&lang=js&"
export * from "./LoginRegisterDialog.vue?vue&type=script&lang=js&"
import style0 from "./LoginRegisterDialog.vue?vue&type=style&index=0&id=3cc1cb1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
